<div class="sidebar flex sticky">
    <h4 class="flex items-center">
        {{ itemTypeTranslationKey | translate }}
        <ui-info class="margin-left-1" tooltipPosition="below" [text]="helperText"></ui-info>
    </h4>

    <div class="fields">
        <div *ngFor="let unmatchedItem of unmatchedList; let index = index" class="field">
            <div *ngIf="unmatchedItem.index !== undefined" class="column-letter margin-right-1">
                {{ convertToBase26Alpha(unmatchedItem.index, true) }}
            </div>
            {{ unmatchedItem.label }}
            <ng-container *ngIf="unmatchedItem.isEmpty"
                >&nbsp;<em> {{ 'import.unmatchedItems.noData' | translate }} </em></ng-container
            >
        </div>
        <div *ngIf="unmatchedList.length === 0">{{ allItemsMatched | translate }}</div>
    </div>
    <div class="remaining-count margin-top-1">
        {{ remainingItemsMatched | translate: { count: unmatchedList.length } }}
    </div>
</div>
